/**
 * @desc 获取多订单退货逆向物流相关信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/getMaterialReverseMsg`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
